var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('SendGiftMenu',{attrs:{"header":"Shopping Bag","back-to":"GiftList","display-stepper":!!_vm.shoppingBagProducts.length}}),[_c('ShoppingBagList')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }